/**
 * Register all firestore collections
 */
enum Collections {
  USERS = 'users',
  POSTS = 'posts',
}

export default Collections;
